import { TranslocoService } from '@jsverse/transloco';
import { Component, inject, Input, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services';
import { transformValue } from '../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { ComplianceService } from '../../services/compliance.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { ComplianceKpiRequest } from '../../models/compliance-kpi.model';

@Component({
  selector: 'app-non-compliant-widget',
  standalone: true,
  imports: [
    KpiWidgetComponent
  ],
  templateUrl: './non-compliant-widget.component.html',
  styleUrl: './non-compliant-widget.component.scss'
})
export class NonCompliantWidgetComponent extends BaseWidgetComponent {
  complianceService = inject(ComplianceService);
  errorHandlerService = inject(ErrorHandlerService);

  @Input() requirementId?: number;

  hasError: boolean = false;
  errorMessage: string = '';

  constructor(
  ) {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = inject(TranslocoService).translate('compliance.shared.widgets.nonCompliant');
    this.widgetDisabled = true;
    this.isLoading = true;
  }

  async onFilterChangeAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;
    this.errorMessage = '';

    try {
      const request: ComplianceKpiRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!,
        regionId: this.widgetFilter.regionId,
        countryId: this.widgetFilter.countryId,
        complianceId: this.widgetFilter.complianceId,
        requirementId: this.requirementId,
        assetTypeId: this.widgetFilter.assetTypeId
      };

      this.cancelSubject.next();
      const response = await this.complianceService.getNonCompliantKpiStatsAsync(request, this.cancelSubject);
      this.value = response?.data?.totalValue ?? 0;
      this.percentageDifference = response?.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  public formatValue(value: number): string {
    return `${transformValue(value)}`;
  }
}